/**
 * Payment methods derived from modalidade + banco.
 * Based on Caixa's public rules:
 *   - Venda Online / Venda Direta Online → aceita Recursos Próprios + Financiamento + FGTS
 *   - Licitação Aberta                   → só Recursos Próprios (à vista)
 *   - Leilão SFI                         → Recursos Próprios + FGTS (sem financiamento)
 *   - Leilão (Santander)                 → só Recursos Próprios
 */

export const PAYMENT_LABEL = {
  proprios:    'Recursos Próprios',
  habitacional:'Financiamento Habitacional',
  fgts:        'FGTS',
};

export const PAYMENT_SHORT = {
  proprios:    'R$',
  habitacional:'Financ.',
  fgts:        'FGTS',
};

/**
 * Returns the list of payment methods scraped from the Caixa detail page.
 * When the scraper hasn't captured it yet (p.formasPagamento is null), returns
 * an empty array so the UI shows nothing instead of misleading heuristic pills.
 * Santander is always cash-only ('proprios').
 */
export function getPaymentMethods(property) {
  if (!property) return [];
  if (property.banco === 'Santander') return ['proprios'];
  if (property.banco !== 'Caixa') return [];
  if (Array.isArray(property.formasPagamento) && property.formasPagamento.length > 0) {
    return property.formasPagamento;
  }
  return [];
}

/** Visual style per modalidade (bg, fg, label). */
export function getModalidadeStyle(modalidade) {
  const m = String(modalidade || '').toLowerCase();
  if (m.includes('leil'))  return { bg: '#fee2e2', fg: '#991b1b', darkBg: 'rgba(239,68,68,.15)', darkFg: '#fca5a5', label: modalidade };
  if (m.includes('licita')) return { bg: '#ede9fe', fg: '#6d28d9', darkBg: 'rgba(167,139,250,.15)', darkFg: '#c4b5fd', label: modalidade };
  if (m.includes('venda'))  return { bg: '#d1fae5', fg: '#065f46', darkBg: 'rgba(52,211,153,.15)', darkFg: '#6ee7b7', label: modalidade };
  return { bg: '#f1f5f9', fg: '#475569', darkBg: 'var(--s2)', darkFg: 'var(--t2)', label: modalidade };
}
